<template>
  <div>
    <kst-output print-mode field="ClientID" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="ClientAddress" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="PONumber" :data="data" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../InvoiceCatalog.js";

export default {
  props: {
    data: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>